import { z } from 'zod';

// Service Request DTO
export const SearchProductsServiceRequestDtoSchema = z.object({
  keyword: z.string().min(1),
  page: z.number().min(1),
  size: z.number().min(1).max(100),
});

export type SearchProductsServiceRequest = z.infer<typeof SearchProductsServiceRequestDtoSchema>;

// Service Response DTO - API Layer와 분리된 독립적인 DTO
export const SearchProductServiceDtoSchema = z.object({
  goodsNo: z.string(),
  goodsName: z.string(),
  brandNo: z.number().nullish(),
  brandName: z.string(),
  imageUrl: z.string(),
  webUrl: z.string(),
  originalPrice: z.number(),
  price: z.number(),
  salesRate: z.number().nullish(),
  couponPrice: z.number().nullish(),
  couponSalesRate: z.number().nullish(),
  hasOptionPrice: z.boolean().nullish(),
  extraDiscountAmount: z.number().int().nullish(),
  finalPrice: z.number().int().nullish(),
  finalDiscount: z.number().int().nullish(),
  isLowestPrice: z.boolean().nullish(),
  isExclusive: z.boolean(),
  existsCoupon: z.boolean().nullish(),
  heartCount: z.number(),
  reviewCount: z.number(),
  reviewScore: z.string(),
  isLiked: z.boolean(),
  likeCount: z.number().optional(),
  expectedEarnings: z.number(),
  largeCategoryNo: z.number().optional().nullable(),
  largeCategoryName: z.string().optional().nullable(),
  middleCategoryNo: z.number().optional().nullable(),
  middleCategoryName: z.string().optional().nullable(),
  smallCategoryNo: z.number().optional().nullable(),
  smallCategoryName: z.string().optional().nullable(),
  hasNextPage: z.boolean(),
  nextPage: z.number().optional(),
});

export const SearchProductsServiceResponseDtoSchema = z.object({
  total: z.number(),
  list: z.array(SearchProductServiceDtoSchema),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type SearchProductService = z.infer<typeof SearchProductServiceDtoSchema>;
export type SearchProductsServiceResponse = z.infer<typeof SearchProductsServiceResponseDtoSchema>;
